import styled from '@emotion/styled';

import IconInfoWarning from '@/assets/icons/icon_info_warning.svg';
import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const Wrapper = styled.div(() =>
  mq({
    width: ['calc(100vw - 80px)', 'calc(100vw - 80px)', 'auto', 'auto'],
    textAlign: 'center',
  }),
);

export const InfoWarningIcon = styled.i(() =>
  mq({
    display: 'inline-block',
    background: `url(${IconInfoWarning}) no-repeat center`,
    backgroundSize: 'cover',
    marginBottom: `${defaultTheme.spacing.l}`,
    width: '40px',
    height: '40px',
  }),
);

export const Text = styled.p(() =>
  mq({
    fontWeight: 'bold',
    marginBottom: `${defaultTheme.spacing.xxl}`,
  }),
);

export const Buttons = styled.div(() =>
  mq({
    display: 'grid',
    gridGap: `${defaultTheme.spacing.l}`,
    margin: '0 auto',
    width: '100%',
    maxWidth: '320px',
  }),
);
